import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If the URL has a #section (e.g. #trial-scope-section), that section
    // is the intended landing spot — don't override it by forcing the
    // page back to the top. CampaignbannerPage's own scroll effect
    // handles getting to that section instead.
    if (hash) return;

    const timeoutId = setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;